import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getGlobalScheduleRulesSummary } from "~/api/global-schedule-rules";

const GLOBAL_SCHEDULE_RULES_SUMMARY_KEY = [
  "global-schedule-rules-summary",
] as const;

export const useGlobalScheduleRulesSummary = () =>
  useQuery({
    queryKey: GLOBAL_SCHEDULE_RULES_SUMMARY_KEY,
    queryFn: getGlobalScheduleRulesSummary,
  });

export const useInvalidateGlobalScheduleRulesSummary = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: GLOBAL_SCHEDULE_RULES_SUMMARY_KEY,
    });
};
